import { render } from "./BoardSelected.vue?vue&type=template&id=0a63b3ba"
import script from "./BoardSelected.vue?vue&type=script&lang=js"
export * from "./BoardSelected.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__